import api from "../security/api";
import axios from "axios";
import constants from "../../utils/constants";

const API_URL = constants.BACKEND;
const save = (client, instance, idOrder, order) => {
    return axios
        .post(`${API_URL}orders/save?client=${client}&instance=${instance}&idOrder=${idOrder}`, order,
            {
                headers: {
                    "Content-Type": "application/json",
                    'Accept': '*/*'
                }
            });
};

const getOrder = (client, instance, taxKey) => {
    return api
        .get(`orders/findAll?client=${client}&instance=${instance}&taxKey=${taxKey}`);
};

const getOrderId = (client, instance, id) => {
    return api
        .get(`orders/findById?client=${client}&instance=${instance}&id=${id}`);
};

const findOwner = (table, taxKey) => {
    return api
        .get(`orders/findOwner?table=${table}&taxKey=${taxKey}`);
};

const searchEntity = (table, taxKey) => {
    return api
        .get(`orders/searchEntity?table=${table}&taxKey=${taxKey}`);
};

const findAllId = (client, instance) => {
    return api
        .get(`orders/findAllId?client=${client}&instance=${instance}`);
};

const findAllbyStatus = (client, instance, status) => {
    return api
        .get(`orders/findAllbyStatus?client=${client}&instance=${instance}&status=${status}`);
};

const order = {
    save,
    getOrder,
    findOwner,
    searchEntity,
    getOrderId,
    findAllId,
    findAllbyStatus
}

export default order;
